import { Link } from 'react-router-dom';
import { Plus, Music, ListMusic, Rss } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { LoginArea } from '@/components/auth/LoginArea';
import { UploadTrackDialog } from '@/components/UploadTrackDialog';
import { CreatePlaylistDialog } from '@/components/CreatePlaylistDialog';
import { ImportFromRSSDialog } from '@/components/ImportFromRSSDialog';
import { NotificationsButton } from '@/components/notifications/NotificationsButton';
import { useCurrentUser } from '@/hooks/useCurrentUser';

interface NavigationProps {
  onPlaylistCreate?: () => void;
  onTrackCreate?: () => void;
}

export function Navigation({ onPlaylistCreate, onTrackCreate }: NavigationProps) {
  const { user } = useCurrentUser();

  return (
    <header className="sticky top-0 z-50 border-b border-white/[0.06] backdrop-blur-md">
      <div className="w-full px-4 py-2 md:px-6 md:py-2">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Link to="/">
              <h1 className="text-2xl font-bold">NodeCast</h1>
            </Link>
          </div>

          <div className="flex items-center gap-3">
            {user && (
              <>
                <NotificationsButton />
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <Button
                      variant="secondary"
                      size="icon"
                      className="h-9 w-9"
                    >
                      <Plus className="h-5 w-5" />
                    </Button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent align="end" className="w-48 glass-strong border border-white/[0.11]">
                    <UploadTrackDialog onSuccess={onTrackCreate}>
                      <DropdownMenuItem
                        onSelect={(e) => e.preventDefault()}
                        className="cursor-pointer"
                      >
                        <Music className="h-4 w-4 mr-2" />
                        Upload Track
                      </DropdownMenuItem>
                    </UploadTrackDialog>
                    <CreatePlaylistDialog onSuccess={onPlaylistCreate}>
                      <DropdownMenuItem
                        onSelect={(e) => e.preventDefault()}
                        className="cursor-pointer"
                      >
                        <ListMusic className="h-4 w-4 mr-2" />
                        Create Playlist
                      </DropdownMenuItem>
                    </CreatePlaylistDialog>
                    <ImportFromRSSDialog>
                      <DropdownMenuItem
                        onSelect={(e) => e.preventDefault()}
                        className="cursor-pointer"
                      >
                        <Rss className="h-4 w-4 mr-2" />
                        Import from RSS
                      </DropdownMenuItem>
                    </ImportFromRSSDialog>
                  </DropdownMenuContent>
                </DropdownMenu>
              </>
            )}
            <LoginArea className="max-w-60" />
          </div>
        </div>
      </div>
    </header>
  );
}
